module.exports = __webpack_public_path__ + "static/media/9.f65aa8e4.jpg";